import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { BackLink } from "@/components/back-link";
import { PageHeader } from "@/components/page-header";
import { orpc } from "@/lib/orpc";
import { PageForm, type PageValues } from "./-components/page-form";

export const Route = createFileRoute("/_admin/content/pages/new")({
	component: NewPagePage,
});

/** Add a page; once saved, the editor of the new page takes over. */
function NewPagePage() {
	const { t } = useTranslation("page");
	const queryClient = useQueryClient();
	const navigate = useNavigate();
	const create = useMutation({
		...orpc.page.create.mutationOptions(),
		onSuccess: () => queryClient.invalidateQueries({ queryKey: orpc.page.key() }),
	});

	const onSubmit = async (values: PageValues) => {
		const page = await create.mutateAsync(values);
		await navigate({ to: "/content/pages/$id", params: { id: page.id }, replace: true });
	};

	return (
		<div className="flex max-w-5xl flex-col gap-6">
			<PageHeader
				back={<BackLink to="/content/pages">{t("title")}</BackLink>}
				title={t("new.title")}
				description={t("new.description")}
			/>
			<PageForm submitLabel={t("new.submit")} onSubmit={onSubmit} />
		</div>
	);
}
